import { useQuery } from "@tanstack/react-query";
import { api } from "../../../../singleton/axios";

export interface HoldingDetailsResponse {
  ticker: string;
  symbol: string;
  name: string;
  shares: number;
  currentPrice: number;
  currentValue: number;
  averageCost: number;
  totalCost: number;
  gainLoss: number;
  gainLossPercent: number;
  dayChange: number;
  dayChangePercent: number;
  logo: string;
  
  // Time-based price changes
  priceChange1w: number;
  priceChangePercent1w: number;
  priceChange1m: number;
  priceChangePercent1m: number;
  priceChange3m: number;
  priceChangePercent3m: number;
  priceChange1y: number;
  priceChangePercent1y: number;
  
  // Dividend information
  dividendsReceived: number;
  dividendYield: number;
  yieldOnCost: number;
  
  lastUpdated: string;
}

export function useHoldingDetails(ticker: string, enabled: boolean = true) {
  return useQuery<HoldingDetailsResponse, Error>({
    queryKey: ["holdingDetails", ticker],
    queryFn: async () => {
      const { data } = await api.get<HoldingDetailsResponse>(`/portfolio/holding-details/${ticker}`);
      return data;
    },
    enabled: enabled && !!ticker,
    refetchOnWindowFocus: false,
    staleTime: 2.5 * 60 * 1000, // 2.5 minutes for fresh holding details
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
}